import React from 'react';
import { Paper, Box, Typography, Button } from '@mui/material';
import { EventBusy, RestartAlt } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function MonthlyEmptyState({ onResetFilters, selectedYear, selectedMonth, selectedZone }) {
    const { t } = useTranslation();

    return (
        <Paper
            elevation={1}
            sx={{
                p: { xs: 4, sm: 6 },
                textAlign: 'center',
                borderRadius: 2,
                bgcolor: 'background.paper',
                border: '1px dashed',
                borderColor: 'divider',
                my: 4,
            }}
        >
            <Box
                sx={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    bgcolor: 'action.selected',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    mb: 2,
                }}
            >
                <EventBusy sx={{ fontSize: 36, color: 'text.secondary' }} />
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                {t('common.noDataForSelectedPeriod', 'No monthly averages data found')}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 460, mx: 'auto', mb: 3 }}>
                {t(
                    'common.noDataHint',
                    'No recorded sensor averages were found for the selected criteria. Try adjusting the year, month, or zone filters.'
                )}
            </Typography>

            {onResetFilters && (
                <Button
                    variant="contained"
                    startIcon={<RestartAlt />}
                    onClick={onResetFilters}
                    sx={{ textTransform: 'none', borderRadius: 2 }}
                >
                    {t('common.resetFilters', 'Reset Filters')}
                </Button>
            )}
        </Paper>
    );
}

export default MonthlyEmptyState;
